import React, { useEffect, useState } from 'react';
import { KTSVG } from '../../../_metronic/helpers';

interface PlreReportPopUpProps {
    selectedJourneyId: string | null;
    isPopUpOpen: boolean;
    setIsPopUpOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const PlreReportPopUp: React.FC<PlreReportPopUpProps> = ({ selectedJourneyId, isPopUpOpen, setIsPopUpOpen }) => {
    const [bookingList, setBookingList] = useState<any[]>([]); // To store booking data
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [itemsPerPage] = useState(10); // Number of items per page
    const [searchTerm, setSearchTerm] = useState(""); // Search term for filtering

    console.log("Selected Jounery ID", selectedJourneyId)

    useEffect(() => {

        if (selectedJourneyId) {
            const fetchBookingData = async () => {
                const requestBody = {
                    shipment_id: selectedJourneyId, // Send shipment_id instead of formatted date
                };

                try {
                    const response = await fetch(
                        "https://backendcway.causewaycargo.com/superadmin/getallbookparticularship",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "auth": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do", // Use correct token here
                            },
                            body: JSON.stringify(requestBody),
                        }
                    );

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const result = await response.json();

                    if (result.status === "success") {
                        const { booking_list_data } = result.data;
                        setBookingList(booking_list_data);
                        console.log("Total Booking data", booking_list_data);
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            };

            fetchBookingData();
        }
    }, [selectedJourneyId]);


    useEffect(() => {
        console.log("Updated bookingList state:", bookingList);
    }, [bookingList]);


    // If popup is closed, don't render anything
    if (!isPopUpOpen) return null;

    // Filter the booking list based on search term
    const filteredBookings = bookingList.filter(booking => {
        // Convert search term to lowercase for case-insensitive search
        const search = searchTerm.toLowerCase();

        // Get the displayed ID (either booking_id or split_id)
        const displayedId = booking.booking_id === null ?
            (booking.split_id ? booking.split_id.toString().toLowerCase() : '') :
            (booking.booking_id ? booking.booking_id.toString().toLowerCase() : '');

        // Check multiple fields that might contain the search term
        return (
            // Check displayed ID (booking_id or split_id)
            displayedId.includes(search) ||
            // Check customer name (consignor or consignee based on who_paid)
            (booking.who_paid === "Consignor" && booking.consignor && booking.consignor.toString().toLowerCase().includes(search)) ||
            (booking.who_paid === "Consignee" && booking.consignee && booking.consignee.toString().toLowerCase().includes(search)) ||
            // Check booking mode
            (booking.booking_mode && booking.booking_mode.toString().toLowerCase().includes(search)) ||
            // Check who paid (which is used as payment method in your table)
            (booking.who_paid && booking.who_paid.toString().toLowerCase().includes(search))
        );
    });

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredBookings.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredBookings.length / itemsPerPage);

    const handlePageChange = (pageNumber: number) => setCurrentPage(pageNumber);

    return (
        <div className="modal-backdrop shadow-lg rounded-5">
            <div className="modal fade show d-block" tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content pb-3 pt-4">
                        <div className="modal-header py-2 d-flex justify-content-end">
                            <span className='close-btn' onClick={() => setIsPopUpOpen(false)}>
                                🗙
                            </span>
                        </div>
                        <div className="modal-body">
                            {selectedJourneyId ? (
                                <>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h3 className='px-8'>Details for Journey ID: {selectedJourneyId}</h3>
                                        <input
                                            type="search"
                                            className="form-control w-25 mb-3"
                                            placeholder="Enter Booking ID"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <div className="card-body py-3 d-flex flex-column flex-md-row">
                                        <div className="table-container flex-grow-1 me-3">
                                            <div className="table-responsive">
                                                <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                                    <thead>
                                                        <tr className="fw-bolder text-muted">
                                                            <th className="min-w-120px">Booking ID</th>
                                                            <th className="min-w-120px">Customer Name</th>
                                                            {/* <th className="min-w-120px">Booking Mode</th> */}
                                                            <th className="min-w-120px">Created At</th>
                                                            <th className="min-w-120px">Booking Mode</th>

                                                            <th className="min-w-120px">Payment method</th>
                                                            {/* <th className="min-w-120px">Payment Method</th> */}
                                                            <th className="min-w-120px">Discount</th>
                                                            <th className="min-w-120px">Total Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentItems.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={8} className="text-center py-4 text-gray-500">🚫 No data available
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            currentItems.map((booking, index) => (
                                                                <tr key={index}>
                                                                    <td className='text-dark fw-bolder text-hover-primary'>{booking.booking_id === null ? booking.split_id : booking.booking_id}</td>
                                                                    <td>{booking.who_paid === "Consignor" ? booking.consignor : booking.consignee}</td>
                                                                    <td>{booking.created_at ? new Date(booking.created_at).toLocaleDateString('en-GB') : 'N/A'}</td>

                                                                    <td>{booking.booking_mode || 'N/A'}</td>

                                                                    <td>{booking.who_paid || 'N/A'}</td>
                                                                    {/* <td>{booking.payment_mode || 'N/A'}</td> */}
                                                                    <td>{booking.total_discount_given || 0}</td>
                                                                    <td>{booking.total_amount || 0}</td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Pagination */}
                                    {currentItems?.length > 10 && <div className="d-flex justify-content-center mt-3 py-3">
                                        {/* Previous Page Button */}
                                        <button
                                            className="btn btn-light-primary me-1 px-4 py-2"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        >
                                            <KTSVG path="/media/icons/duotune/arrows/arr079.svg" className="svg-icon-3" />
                                        </button>

                                        {/* Page Numbers */}
                                        <div>
                                            {Array.from({ length: totalPages }, (_, i) => {
                                                const pageNumber = i + 1;

                                                // Show first page, last page, and pages near the current page
                                                if (
                                                    pageNumber === 1 ||
                                                    pageNumber === totalPages ||
                                                    Math.abs(pageNumber - currentPage) <= 1
                                                ) {
                                                    return (
                                                        <button
                                                            key={pageNumber}
                                                            className={`btn btn-light-primary mx-1 px-4 py-2 ${currentPage === pageNumber ? "active" : ""
                                                                }`}
                                                            onClick={() => handlePageChange(pageNumber)}
                                                        >
                                                            {pageNumber}
                                                        </button>
                                                    );
                                                }

                                                // Ellipsis for gaps
                                                if (
                                                    (pageNumber === currentPage - 2 && pageNumber > 1) ||
                                                    (pageNumber === currentPage + 2 && pageNumber < totalPages)
                                                ) {
                                                    return (
                                                        <span key={pageNumber} className="mx-2 text-muted">
                                                            ...
                                                        </span>
                                                    );
                                                }

                                                return null; // Skip rendering other pages
                                            })}
                                        </div>

                                        {/* Next Page Button */}
                                        <button
                                            className="btn btn-light-primary px-4 py-2 ms-1"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        >
                                            <KTSVG path="/media/icons/duotune/arrows/arr080.svg" className="svg-icon-3" />
                                        </button>
                                    </div>}
                                </>
                            ) : (
                                <p>No journey selected.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlreReportPopUp;
